import React, { FC } from "react";

export type Props = Record<string, never>;
export const GeneralFoot: FC<Props> = () => <></>;
